import { range } from "lodash";
import moment from "moment";
import { useMemo } from "react";
import {
  MostRecentAssessmentAnswerNode,
  OverallGoalAssessmentQuestionNode,
  OverallRecognitionCoreValueAssessmentQuestionNode,
  RangeAssessmentQuestionNode,
  TalentIndicatorAssessmentQuestionNode,
} from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import Tooltip from "@components/tooltip/tooltip";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";

const PrevAnswerChip = ({
  prevAnswer,
  question,
}: {
  question:
    | Pick<
        TalentIndicatorAssessmentQuestionNode,
        "__typename" | "labels" | "startValue" | "endValue"
      >
    | Pick<
        RangeAssessmentQuestionNode,
        "__typename" | "labels" | "startValue" | "endValue"
      >
    | Pick<
        OverallGoalAssessmentQuestionNode,
        "__typename" | "labels" | "startValue" | "endValue"
      >
    | Pick<
        OverallRecognitionCoreValueAssessmentQuestionNode,
        "__typename" | "labels" | "startValue" | "endValue"
      >;
  prevAnswer: Pick<
    MostRecentAssessmentAnswerNode,
    "integerAnswer" | "submitted"
  >;
}) => {
  const label = useLabel();
  const answerLabels = useMemo(
    () =>
      range(question.startValue, question.endValue + 1).reduce(
        (acc, value, index) => ({
          ...acc,
          [value]: question.labels[index] || value.toString(),
        }),
        {} as Record<string, string>
      ),
    [question]
  );
  return (
    <Tooltip
      text={
        prevAnswer.integerAnswer
          ? `Last ${label("review", { capitalize: true })} Score: ${
              answerLabels[prevAnswer.integerAnswer]
            }<br/>${moment(prevAnswer.submitted).format("MMMM Do YYYY")}`
          : `No "Last ${label("review", { capitalize: true })} Score" available`
      }
    >
      <div className="flex items-center gap-2 py-1 px-2 bg-gray-50 rounded-md text-gray-500">
        <TopicflowIcon type="previous" className="h-4 w-4" />
        <div>
          {prevAnswer.integerAnswer
            ? answerLabels[prevAnswer.integerAnswer]
            : "N/A"}
        </div>
      </div>
    </Tooltip>
  );
};

export default PrevAnswerChip;
